import { render } from "./NoticeComponent.vue?vue&type=template&id=d714a308&scoped=true&lang=pug"
import script from "./NoticeComponent.vue?vue&type=script&lang=js"
export * from "./NoticeComponent.vue?vue&type=script&lang=js"

import "./NoticeComponent.vue?vue&type=style&index=0&id=d714a308&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d714a308"]])

export default __exports__